module.exports = __webpack_public_path__ + "media/images/healthcare-03397b4619e8999a66f57945d776a5b0.svg";